// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nuxt-link-active[data-v-48c70b4c]{\n  --tw-text-opacity:1;\n  color:rgba(29, 185, 84, var(--tw-text-opacity))\n}\n.isMobile[data-v-48c70b4c]{\n  position:absolute;\n  top:0px;\n  right:0px;\n  bottom:0px;\n  left:0px\n}\n.isTablet[data-v-48c70b4c]{\n  position:absolute;\n  top:0px;\n  bottom:0px;\n  right:0px\n}\n.isDesktop[data-v-48c70b4c]{\n  padding:0.75rem;\n  padding-right:3rem\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
